
$(document).ready(function() {
  var player = $("video:visible")[0];
  if(player){
    // Interval time in milliseconds
    var intervalTime = 500; // Check every 100 milliseconds
    
    // Function to check for the element
    var checkForElement = setTimeout(function() {
      player.play();
    }, intervalTime);

    $(".vid-control").on("click", function() {
        var e = $(this).siblings("video:visible")[0];
        e.paused ? e.play() : e.pause()
    });
    $("video:visible").each(function(e) {
        var t = $(this);
        t.on("pause ended", function() {
            t.siblings(".vid-control").addClass("hd-active").attr("aria-pressed", "true")
        }).on("play", function() {
            t.siblings(".vid-control").removeClass("hd-active").attr("aria-pressed", "false")
        })
    });

  } 
});

